import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../LazyComponent';

export default universal(
    universalImport({
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "MyInfoWrapperChunks" */ './MyInfoWrapper'), // css name
            ]).then((proms) => proms[0]),
        chunkName: () => 'LazyCAMChunks',
        path: () => path.join(__dirname, './MyInfoWrapper'),
        resolve: () => require.resolveWeak('./MyInfoWrapper'),
    }),
    LazyComponent.loaderResource
);
